import { ChangeEvent, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import '../../../css/uploadPhoto.css'
import { uploadProfileImage } from './../../../services/mediaService';
import { useHistory } from "react-router";
import { COMPLETE_QUESTIONS, COMPLETE_SIGNUP, HOMEPAGE, SELECT_MOOD } from "../../../navigation/Constants";
import { setOpenMoodSelectQuestions, setRegistrationComplete } from "../../../redux/app";
import account from '../../../services/accountService'
import Loader from "react-loader-spinner";
import { MODAL_TYPES, useGlobalModalContext } from "../../../components/GlobalModal";
import { convertBase64ToBlob } from "../../../helpers/Functions";
import { RootState } from "../../../redux/store";
import http from '../../../services/httpService'
import { resetSignupData } from "../../../redux/signup";
import NiceModal from "@ebay/nice-modal-react";
import { recordGaEvent } from "../../../helpers/GoogleAnalytics";
import { GAActions, GACategoryName, GAEventNames, GAUniqueEventIds } from "../../../helpers/Enums";
import { sendMessageToWebview } from "../../../services/native";


interface CustomWindow extends Window {
    dataLayer: any;
    fbq?: (action: string, event: string) => void;
}
declare let window: CustomWindow;

const ProfileImageQuestion = (props: any) => {
    const [selectedFile, setSelectedFile] = useState<File>();
    const [image, setImage] = useState<string>();
    const [croppedImg, setCroppedImg] = useState<string>();
    const [showLoader, setShowLoader] = useState<boolean>(false);
    const [showCropImageModal, setShowCropImageModal] = useState(false);
    const [hasUserSelectedImage, setHasUserSelectedImage] = useState(false);
    const { showModal } = useGlobalModalContext();
    const register = useSelector((state: RootState) => state.signup);
    let history = useHistory();
    const dispatch = useDispatch();


    useEffect(() => {
        if (showCropImageModal)
            showCropper(image);
        return () => setShowCropImageModal(false);
    }, [showCropImageModal])

    //Google Analytics


    const handleSubmit = async (event: any, uploadPicture = true) => {
        event.preventDefault();
        setShowLoader(true);
        try {
            await handleRegisterAccount();
            const token = account.getJwt();
            if (token) {

                const { unique_name }: any = account.getCurrentUser();
                if (uploadPicture)
                    await uploadProfileImage(unique_name, convertBase64ToBlob(croppedImg), true);

                dispatch(setRegistrationComplete(true));

                recordGaEvent(GAEventNames.APP_SIGNUP, GACategoryName.SIGNING_STEPS, "step 11", "אישור הרשמה", GAUniqueEventIds.APP_SIGNUP)
                recordGaEvent(GAEventNames.REGISTRATION, GACategoryName.NAME, GAActions.REGISTRATION, register.nickName, GAUniqueEventIds.REGISTRATION); //Google Analytics

                setShowLoader(false);
                history.replace(HOMEPAGE);
                history.push(SELECT_MOOD);
                // history.push(COMPLETE_SIGNUP)
                if (window && window.fbq) {
                    window.fbq('track', 'Lead');
                }

                if (window.platform === 'android' || window.platform === 'ios')
                    sendMessageToWebview("auth-token", { token });
            }
        }
        catch (error: any) {
            NiceModal.show("error_modal", {
                headerTitle: "שגיאה",
                errorContent: "שגיאה לא צפויה בהעלאת התמונה",
            });
            setShowLoader(false);
            console.log(error);
        }
    };


    const handleRegisterAccount = async () => {
        const { data } = await account.register(register);
        dispatch(resetSignupData());
        localStorage.setItem("token", data.accessToken);

        http.setJwt(data.accessToken);
    };

    const showCropper = (url: any) => {
        showModal(MODAL_TYPES.IMAGE_CROPPER, {
            imgURL: image,
            setCropImage: setCroppedImg,
            buttonText: "קבע כתמונת פרופיל"
        });
    };



    const onSelectFile = async (e: ChangeEvent<HTMLInputElement>) => {
        e.preventDefault();
        const { files } = e.target;
        if (files && files?.length > 0) {
            const reader = new FileReader();
            if (!reader) return;
            reader.onload = () => {
                setImage(reader.result?.toString());
                e.target.value = '';
                setShowCropImageModal(true);
                //e.target.value = null;
            };
            reader.readAsDataURL(files[0]);
            setHasUserSelectedImage(true);
        }
        else return;
    };

    const unSelectFile = () => {
        setImage(undefined)
        setCroppedImg(undefined)
        setSelectedFile(undefined)
        setHasUserSelectedImage(false);
    };


    const enabled = croppedImg !== undefined;


    return (
        <>
            <div className="content_sec wf-section">

                <div className="signup_top_info">
                    <div className="icon_info"><img src="~/assets/images/ic_info_smoke.svg" loading="lazy" alt="" /></div>
                    <h2 className="signup_title">תמונת פרופיל</h2>
                    <div>כדי שאחרים יוכלו לראות את הפרופיל שלך מומלץ מאד להוסיף תמונת פרופיל</div>
                </div>
                <div className="login_sec w-form">
                    <form onSubmit={handleSubmit}>
                        <ul className="signup_pict_list w-list-unstyled" style={{ justifyContent: 'center', alignItems: 'center' }}>
                            <li className="edit_pict_item" style={{ maxWidth: '300px', margin: '0' }}>
                                {croppedImg
                                    ?
                                    <>
                                        <a href="#" onClick={unSelectFile} className="signup_pict_link delete w-inline-block"></a>
                                        <img src={croppedImg} loading="lazy" alt="" className="item_pict" />
                                    </>
                                    :
                                    <>
                                        <img loading="lazy" alt="" className="item_pict no_upload" />
                                        <a href="#" className="signup_pict_link w-input"></a>
                                        <input autoComplete="off" style={{ opacity: 0 }} onChange={onSelectFile} type="file" className="signup_pict_link w-input" name="field-2" data-name="Field 2" id="field-2" />
                                    </>
                                }
                            </li>
                        </ul>
                        <div className="form_buttons_group skip">

                            {showLoader
                                ? <button disabled={true} className="button_full w-button">
                                    <Loader
                                        type="Oval"
                                        color="white"
                                        height={22}
                                        width={30}
                                    />
                                </button>
                                :
                                <>
                                    <input autoComplete="off" type="submit" value={"סיום"} data-wait="" className={"button_full w-button"} style={!enabled ? { display: "none" } : { display: "block" }} />
                                    <a href="#" onClick={(e) => handleSubmit(e, false)} className="skip_link">אוסיף יותר מאוחר</a>
                                </>
                            }
                        </div>

                    </form>
                </div>
            </div>
        </>
    )
}

export default ProfileImageQuestion;
